import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { UnitChangeRequest } from './unit-change-request';

@Component({
  selector: 'cs-unit-change-requests',
  standalone: false,
  templateUrl: './unit-change-requests.component.html',
  styleUrls: ['./unit-change-requests.component.scss']
})
export class UnitChangeRequestsComponent implements OnInit, OnDestroy {
  public unitChangeRequests: Array<UnitChangeRequest>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;

  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getUnitChangeRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.unitChangeRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: UnitChangeRequest): void {
    this.router.navigate(['/crm/customers/unit-change-requests/approval'], {
      queryParams: { unitChangeRequestId: request.unitChangeRequestId }
    });
    this.closeTodo.emit();
  }
}
